import { Checkbox as MuiCheckbox } from '@material-ui/core';
import { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import React, { FC } from 'react';

export interface CheckboxBaseProps {
  error?: boolean;
}

export type CheckboxProps = CheckboxBaseProps & MuiCheckboxProps;

/**
 * @deprecated Prefer `Checkbox` from @material-ui/core.
 * @example
 * -- import { Checkbox } from '@fountain/fountain-ui-components';
 * ++ import { Checkbox } from '@material-ui/core';
 *
 * -- <Checkbox error={error} />
 * ++ <Checkbox className={classNames({ error })} />
 */
export const Checkbox: FC<CheckboxProps> = ({ error, ...props }) => (
  <MuiCheckbox {...props} className={classNames(props.className, { error })} />
);
